import React from 'react';
import CaspianTimePicker from '../../CaspianTimePicker';

class CaspianTimePickerInput extends React.Component {
  static defaultProps = {
    value: '',
    onChange: () => {},
    disabled: false,
  };

  render() {
    return (
      <CaspianTimePicker
        selectedDate={this.props.value}
        onChange={(newTime) => this.props.onChange(newTime)}
        disabled={this.props.disabled}
      />
    );
  }
}

export default CaspianTimePickerInput;
